import React, { FC, Dispatch, SetStateAction } from 'react'
import dynamic from 'next/dynamic'
import noSSR from 'components/DynamicLoader'

type Props = {
  shouldLoadComponent: boolean
  setShouldLoadComponent: Dispatch<SetStateAction<boolean>>
}
const VisuallySimilarCarousel = dynamic(
  import(
    /* webpackChunkName: "VisuallySimilarCarousel" */
    './Carousel'
  ),
  noSSR
)

const VisuallySimilar: FC<Props> = (props) => {
  const { shouldLoadComponent, setShouldLoadComponent } = props

  return (
    <VisuallySimilarCarousel
      shouldLoadComponent={shouldLoadComponent}
      setShouldLoadComponent={setShouldLoadComponent}
    />
  )
}

export default VisuallySimilar
